module.exports = __webpack_public_path__ + "static/media/Finnovex-Europe-2024.32660d6b.png";